import { Category } from '../types/news.types';

export const CATEGORIES: Record<string, Category> = {
  TECH: {
    value: 'tech',
    label: 'Technology',
    description: 'Latest technology news and updates',
    color: '#3B82F6',
    icon: '💻',
  },
  INNOVATION: {
    value: 'innovation',
    label: 'Innovation',
    description: 'Breakthrough innovations and ideas',
    color: '#8B5CF6',
    icon: '💡',
  },
  EARLY_BIRDS: {
    value: 'early-birds-startup',
    label: 'Early Birds Startup',
    description: 'Emerging startups to watch',
    color: '#10B981',
    icon: '🚀',
  },
  UNICORN: {
    value: 'unicorn',
    label: 'Unicorn',
    description: 'Billion-dollar startup stories',
    color: '#F59E0B',
    icon: '🦄',
  },
  RECOGNITION: {
    value: 'recognition',
    label: 'Recognition',
    description: 'Awards and achievements',
    color: '#EF4444',
    icon: '🏆',
  },
  STARTUPRAHI: {
    value: 'startuprahi',
    label: 'Startup Rahi',
    description: 'Startup journey stories',
    color: '#F97316',
    icon: '🛤️',
  },
  MANUFACTURING: {
    value: 'manufacturing',
    label: 'Manufacturing',
    description: 'Manufacturing industry insights',
    color: '#6366F1',
    icon: '🏭',
  },
  STOCK_MARKET: {
    value: 'stock-market',
    label: 'Stock Market',
    description: 'Stock market news and analysis',
    color: '#14B8A6',
    icon: '📈',
  },
  MARKETING: {
    value: 'marketing',
    label: 'Marketing',
    description: 'Marketing trends and strategies',
    color: '#EC4899',
    icon: '📱',
  },
  TRENDING: {
    value: 'trending',
    label: 'Trending',
    description: 'Hot topics and viral news',
    color: '#DC2626',
    icon: '🔥',
  },
  FEATURED: {
    value: 'featured',
    label: 'Featured',
    description: "Editor's picks and highlighted stories",
    color: '#7C3AED',
    icon: '⭐',
  },
  STORIES: {
    value: 'stories',
    label: 'Stories',
    description: 'Inspiring stories and narratives',
    color: '#0891B2',
    icon: '📖',
  },
  WOMEN_EMPOWERMENT: {
    value: 'women-empowerment',
    label: 'Women Empowerment',
    description: 'Women leaders and empowerment initiatives',
    color: '#DB2777',
    icon: '👩‍💼',
  },
  FARMING: {
    value: 'farming',
    label: 'Farming',
    description: 'Agriculture, farming tech, and rural innovation',
    color: '#65A30D',
    icon: '🌾',
  },
  CASE_STUDY: {
    value: 'case-study',
    label: 'Case Study',
    description: 'In-depth business case studies and analysis',
    color: '#0369A1',
    icon: '📊',
  },
  LATEST_NEWS: {
    value: 'latest-news',
    label: 'Latest News',
    description: 'The latest news updates from around the world',
    color: '#ff9e43',
    icon: '📰',
  },
  TOP: {
    value: 'top',
    label: 'Top News',
    description: 'The Top news updates of the day',
    color: '#ff9e43',
    icon: '📈',
  },
};

/**
 * Get category by value
 */
export const getCategoryByValue = (value: string): Category | undefined => {
  return Object.values(CATEGORIES).find((cat) => cat.value === value);
};

/**
 * Get category color
 */
export const getCategoryColor = (category: string): string => {
  const cat = getCategoryByValue(category);
  return cat?.color || '#6B7280';
};

/**
 * Get category label
 */
export const getCategoryLabel = (category: string): string => {
  const cat = getCategoryByValue(category);
  return cat?.label || category;
};